const NAV = {
    header: document.getElementById('header'),
    onReady() {
        // NAV.show();
        NAV.highlight();
    },
    show() {
        var lastScrollTop = 0;
        window.addEventListener('scroll', () => {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop || lastScrollTop < 100) {
                // downscroll code
                header.classList.remove('show');
            } else {
                // upscroll code
                header.classList.add('show');
            }
            lastScrollTop = st <= 0 ? 0 : st;
        }, false);
    },
    highlight() {
        let url      = window.location.pathname;
        let urlArr   = url.split('/');
        let navItems = document.querySelectorAll('.sub-nav__link');
        if (urlArr[1] === '') return;
        navItems.forEach(item => {
            let href = item.dataset.href ? item.dataset.href : item.href; // Elvis Operator would fit perfectly here, but isn't supported yet
            urlArr[1].includes(href) && item.classList.add('is-active');
        });
    },
    burgerClick(that) {
        that.classList.toggle('cross');
        let mainNav = document.getElementById('main-nav');
        let header  = document.getElementById('header');
        let subNav  = document.getElementById('sub-nav');
        let info    = document.getElementById('modal-imprint-toggle');
        let scp     = document.getElementById('header-scp-logo');
        if (mainNav !== null) mainNav.classList.toggle('active');
        if (header !== null) header.classList.toggle('active');
        if (subNav !== null) subNav.classList.toggle('active');
        if (info !== null) info.classList.toggle('is-hidden');
        if (scp !== null) scp.classList.toggle('is-hidden');
    }
}